import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProctorComponent } from './proctor/app-proctor.component';
import { SecondViewComponent } from './second-view/second-view.component';
import { IndexComponent } from './index/index.component';
import { AwaitProctorComponent } from './await-proctor/await-proctor.component';

const routes: Routes = [
  {
    path: '', component: IndexComponent, pathMatch: "full"
  },
  {
    path: 'proctor', component: ProctorComponent, pathMatch: "full"
  },
  {
    path: 'secondview', component: SecondViewComponent, pathMatch: "full"
  },
  {
    path: 'please-wait', component:AwaitProctorComponent, pathMatch: "full",
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
